var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('h6',[_vm._v(_vm._s(this.$t('HttpResponseStatus')))]),_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.tableData,"rowKey":"second","bordered":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }